import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ampmLowercase',
})
export class AmPmLowercasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/\b(AM|PM)\b/, (match) => match.toLowerCase());
  }
}
